import { render } from "./GeneralTemplateMKBInput.vue?vue&type=template&id=cce0078e"
import script from "./GeneralTemplateMKBInput.vue?vue&type=script&lang=js"
export * from "./GeneralTemplateMKBInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__